import { ReactNode } from "react";
import { Flex, Text } from "@radix-ui/themes";

interface InteractionViewTabContentEmptyStateProps {
  title: string;
  description?: string;
  icon?: ReactNode;
}

export function InteractionViewTabContentEmptyState({
  title,
  description,
  icon,
}: InteractionViewTabContentEmptyStateProps) {
  return (
    <Flex pt={"100px"} direction={"column"} gap={"1"} align={"center"}>
      {icon}

      <Text size={"3"} weight={"medium"} color="gray" highContrast>
        {title}
      </Text>

      {description != null && (
        <Text size={"2"} color="gray" className="max-w-[440px] text-center">
          {description}
        </Text>
      )}
    </Flex>
  );
}
